<template>
    <v-client-table :data='getMateriels'
      class="column is-12 displayNoneVuePagination"
      :columns="columns" :options="options"
      ref="tableDispoMateriel">
      <div slot="code" slot-scope="props">
        <router-link-blank :to="{ name: 'c.gabed.emplacement-detailMateriel',
                      params: { id: props.row.emplacementId,
                        idMateriel: props.row.id }}"
                      :class="{'text-access-no-permission':
                        !checkPermissions(permEmplacement.lecture)}"
                      :message="props.row.code ">
                    </router-link-blank>
      </div>
      <div slot="format.libelle" slot-scope="props">
        {{ props.row.format ? props.row.format.libelle : '' }}
      </div>
      <div slot="eclaire" slot-scope="props">
        {{ props.row.eclaire ? $t('general.oui') : $t('general.non')  }}
      </div>
      <div slot="type.libelle" slot-scope="props">
        {{ props.row.type ? props.row.type.libelle : '' }}
      </div>
    </v-client-table>
  </template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';

const Permissions = createNamespacedHelpers('permissions');

export default {
  name: 'materielsForClients',
  props: {
    data: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      permEmplacement: EMPLACEMENT,
    };
  },
  components: {
    routerLinkBlank,
  },
  computed: {
    getMateriels() {
      const materiels = cloneDeep(this.data.materiels);
      return materiels;
    },
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$i18n.t('detailClient.dispositif.tab.code'),
          disposition: this.$i18n.t('listeMateriel.tab.disposition'),
          'type.libelle': this.$i18n.t('detailClient.dispositif.tab.typeMateriel'),
          'format.libelle': this.$i18n.t('detailClient.dispositif.tab.format'),
          eclaire: this.$i18n.t('detailClient.dispositif.tab.eclaire'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        columnsClasses: {
          code: 'width-250',
        },
      };
    },
    columns() {
      return ['code', 'disposition', 'format.libelle', 'type.libelle', 'eclaire'];
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
  },
};

</script>
